(() => {
  const selector = '.mytea-subscribe-products';

  function initSubscribeProducts(section) {
    if (!section || section.dataset.frequencyInitialized === 'true') return;

    const controls = section.querySelector('[data-subscribe-frequency]');
    if (!controls) return;

    const buttons = Array.from(controls.querySelectorAll('[data-weeks]'));
    const labels = Array.from(section.querySelectorAll('[data-product-frequency]'));
    const prices = Array.from(section.querySelectorAll('[data-product-subscription-price]'));

    const setFrequency = (weeks) => {
      buttons.forEach((button) => {
        const isActive = button.dataset.weeks === weeks;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      labels.forEach((label) => {
        label.textContent = label.getAttribute(`data-label-${weeks}`) || '';
      });

      prices.forEach((price) => {
        const nextPrice = price.getAttribute(`data-price-${weeks}`);
        if (nextPrice) price.textContent = nextPrice;
      });

      section.querySelectorAll('[data-subscription-link]').forEach((link) => {
        link.href = link.getAttribute(`data-link-${weeks}`);
        link.textContent = link.getAttribute(`data-text-${weeks}`);
      });
      section.dataset.deliveryWeeks = weeks;
    };

    controls.addEventListener('click', (event) => {
      const button = event.target.closest('[data-weeks]');
      if (!button || !controls.contains(button)) return;
      setFrequency(button.dataset.weeks);
    });

    section.dataset.frequencyInitialized = 'true';
    setFrequency(buttons.find((button) => button.classList.contains('is-active'))?.dataset.weeks || '2');
  }

  function initAll(root = document) {
    if (root.matches?.(selector)) initSubscribeProducts(root);
    root.querySelectorAll?.(selector).forEach(initSubscribeProducts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
